import { createSelector } from '@reduxjs/toolkit';

import { EssQuestionValue } from '@/domain/impact-ess/entities/question.entity.ts';
import { RootState } from '@/domain/store';

export const selectImpactEssQuestions = (state: RootState) => {
  return state.impactEss.questions;
};

export const selectImpactEssResponses = (state: RootState) => {
  return state.impactEss.responses;
};

export const selectEssDebugMode = (state: RootState) => {
  return state.impactEss.debugMode;
};

export const selectImpactEssAnswersMap = createSelector(
  [selectImpactEssResponses],
  (impactEssResponses) => {
    const impactEssResponsesMap: Map<string, EssQuestionValue> = new Map();
    for (const essResponse of impactEssResponses) {
      impactEssResponsesMap.set(essResponse.paramId, essResponse);
    }
    return impactEssResponsesMap;
  },
);
